// This is the existing site's GA4 web stream, not a new tracker or an API secret.
export const JOURNEY_MEASUREMENT_ID = 'G-5JLEVREB1G';
export const JOURNEY_EVENTS = ['sign_up', 'journal_first_plant', 'journal_first_entry', 'journal_open', 'journal_return'];

export function journeySurface({referrer = '', standalone = false} = {}) {
  if (/^android-app:\/\/ru\.uogorod\.app(?:\/|$)/.test(referrer)) return 'android_app';
  return standalone ? 'web_app' : 'browser';
}

export function journeyParameters(event, surface) {
  return {
    send_to: JOURNEY_MEASUREMENT_ID,
    app_surface: ['android_app', 'web_app', 'browser'].includes(surface) ? surface : 'browser',
    journey_version: '1',
    page_location: 'https://uogorod.ru/' + (event === 'sign_up' ? 'auth/activate' : 'journal'),
    page_title: event === 'sign_up' ? 'Регистрация завершена' : 'Журнал посадок',
    page_referrer: 'https://uogorod.ru/',
    ...(event === 'sign_up' ? {method: 'email'} : {}),
    transport_type: 'beacon',
  };
}

export function createJourneyTracker({request, send, surface, enabled = () => true}) {
  // Serialise claims so a simultaneous save and navigation cannot reverse the funnel.
  let queue = Promise.resolve();
  return action => {
    if (!['activation', 'observe', 'journal'].includes(action) || !enabled()) return Promise.resolve([]);
    queue = queue.then(async () => {
      try {
        const result = await request(action);
        const events = [...new Set(result?.events || [])].filter(event => JOURNEY_EVENTS.includes(event));
        for (const event of events) send(event, journeyParameters(event, surface));
        return events;
      } catch { return []; } // Analytics must never break registration or a saved journal.
    });
    return queue;
  };
}

let tracker;
export function trackJourney(action) {
  if (typeof window === 'undefined') return Promise.resolve([]);
  if (!tracker) tracker = createJourneyTracker({
    surface: journeySurface({referrer: document.referrer, standalone:
      window.matchMedia?.('(display-mode: standalone)').matches || navigator.standalone === true}),
    enabled: () => location.hostname === 'uogorod.ru' && navigator.doNotTrack !== '1'
      && window.doNotTrack !== '1' && navigator.globalPrivacyControl !== true,
    request: async action => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 1500);
      try {
        const response = await fetch('/api/analytics/journey', {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type':'application/json'},
          body: JSON.stringify({action}), signal: controller.signal,
        });
        if (!response.ok) return {events: []};
        return await response.json();
      } finally { clearTimeout(timer); }
    },
    send: (event, parameters) => {
      window.dataLayer = window.dataLayer || [];
      // Use the already installed Google tag; do not configure a second page-view tag.
      function gtag() { window.dataLayer.push(arguments); }
      gtag('event', event, parameters);
    },
  });
  return tracker(action);
}
